module.exports = __webpack_public_path__ + "static/img/rtc-ico-done.3006d2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/rtc-ico-done.png
// module id = uxd6
// module chunks = 1